<div class="container dialog-container">

  <h2 class="display-6">
    Edit Gear: {{gearName}}
  </h2>

  <!-- Delete or add new species -->
  <div class="row buttons">

    <button mat-fab
            class="text-blue-button"
            type="button"
            aria-label="Cancel"
            (click)="onNoClick()">
      Cancel
    </button>



    <button *ngIf="!data.isHMS"
            mat-fab
            class="text-button"
            type="button"
            aria-label="Edit Gear"
            (click)="editGear()">
      Edit
    </button>

    <button *ngIf="data.isHMS"
            mat-fab
            class="text-button"
            type="button"
            aria-label="Delete Gear"
            (click)="deleteGear()">
      Delete
    </button>

  </div>

</div>
